// Clear any stale assumption on page load. sessionStorage survives a refresh
// but React state does not, so without this an assumed-user header could
// keep being sent with no "you are impersonating" banner visible to stop it.
// This runs here (rather than in useAuth.tsx, where the assumption lives)
// because every module that builds a scoped query key imports this module
// for `currentScope` — so the purge is guaranteed to happen before the first
// key is built, regardless of module import order elsewhere in the app.
sessionStorage.removeItem('assumedUserId');

// The physical cache-scope key for the currently active identity. Reads the
// same sessionStorage value the axios `X-Assume-User-Id` header is built
// from (src/api/helpers.ts), so impersonated data is keyed into a separate
// cache subtree and can never collide with the real user's data.
export type AssumedScope = number | 'self';

export function currentScope(): AssumedScope {
  const raw = sessionStorage.getItem('assumedUserId');
  return raw ? Number(raw) : 'self';
}
